export const INHABITANT_STATUS = [
  {
    text: 'InhabitantTable.InvitedStatus',
    textColor: 'var(--color-in-progress)',
  },
  { text: 'InhabitantTable.OnlineStatus', textColor: 'var(--color-success)' },
  { text: 'InhabitantTable.ImportedStatus', textColor: 'var(--color-info)' },
  { text: 'InhabitantTable.BlockedStatus', textColor: 'var(--color-error)' },
  { text: 'InhabitantTable.InvalidStatus', textColor: 'var(--color-declined)' },
]
